import React from 'react'
import './CardFour.css'

function CardFour() {
    return (
        <div className="cardFour">
            <div className="line_one">
                <div className="heading">
                <h1>86,000</h1>
                <h5>customers in over 120 countries<br/> growing their businesses with HubSpot</h5>
                </div>
                
                <div className="company_logo">
                    <img src="https://www.hubspot.com/hubfs/assets/hubspot.com/home/home_page_logos_June_2019/Atlassian-horizontal-blue@2x.png"
                    alt="" />

                    <img src="https://www.hubspot.com/hubfs/assets/hubspot.com/home/home_page_logos_June_2019/doordash_owler_20181011_194113_original@2x.png"
                    alt="" />

                    <img src="https://www.hubspot.com/hubfs/assets/hubspot.com/home/home_page_logos_June_2019/g2crowd-logo@2x.png" 
                    alt="" />

                    <img src="https://www.hubspot.com/hubfs/assets/hubspot.com/homepage/Vertical_Sabaeus_RGB.svg" alt="" />

                
                </div>

                <div className="company_logo">
                <img src="https://www.hubspot.com/hubfs/assets/hubspot.com/home/home_page_logos_June_2019/Subaru_Logo_v2_186x63@2x.png"
                alt="" />

                <img src="https://www.hubspot.com/hubfs/assets/hubspot.com/home/home_page_logos_June_2019/Wistia_logo@2x.png"
                alt="" />

                <img src="https://www.hubspot.com/hubfs/assets/hubspot.com/home/home_page_logos_June_2019/Classpass-logo@2x.png"
                alt="" />

                <img src="https://www.hubspot.com/hubfs/assets/hubspot.com/home/home_page_logos_June_2019/VMware_logo_gry_RGB_300dpi@2x.png"
                alt="" />
            </div>
    
            </div>

            <div className="card_description">
                <div className="description_text">
                    <h2>Start Growing With HubSpot<br/> Today</h2>
                    <p>With tools to make every part of your process more human<br/> and a support team excited to help you, getting started<br/> with inbound has never been easier.</p>    
                    
                    <button className="description_button">Get HubSpot Free</button>
                    <p>Get started with FREE tools, or get more with our premium software.</p>    
                </div>

                <img
                className="description_image"
                src="//cdn2.hubspot.net/hubfs/53/assets/hubspot.com/_style-guide/sword-sprocket/Variation-3@2x.png"
                alt="" />
            </div>
           

            </div>
    )
}

export default CardFour
